/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { Suspense, useEffect, useState } from 'react';

// import { createIntl } from 'react-intl';
// import { IntlProvider } from 'react-intl-redux';

import { Route, BrowserRouter, Switch } from 'react-router-dom';
// import Logger from './Logger';
import debug from 'debug';
import deviceInfo from './deviceInfo';
import LoadingView from './components/Loader/LoadingView';
// import { createMuiTheme } from '@material-ui/core/styles';
import { store } from './store/store';
import { SnackbarProvider } from 'notistack';
// import { LazyPreload } from './components/Loader/LazyPreload';
// import loadJS from 'load-js';
import './index.css';
import './invc.css';

// import { config } from './config';
import DesktopRoomsPlugins from './components/DesktopRoomsPlugins/index';
import ConferenceRoom from './components/DesktopRoomsPlugins/components/conferenceRoom/index';
import VcComponent from './VcComponent';
import io from 'socket.io-client';
import ControllerContext from './RoomControllerSocketContext';
import ControllerPair from './components/DesktopRoomsPlugins/controllerPair';
import * as roomActions from './store/actions/roomActions';
import axios from 'axios';
import { decodeToken } from 'react-jwt';

// const App = LazyPreload(() => import(/* webpackChunkName: "app" */ './components/App'));
// const cache = createIntlCache();

// const supportedBrowsers =
// {
// 	'windows' : {
// 		'internet explorer' : '>12',
// 		'microsoft edge'    : '>18'
// 	},
// 	'safari'                       : '>12',
// 	// 'Safari'                      	: '',
// 	'firefox'                      : '>=60',
// 	'chrome'                       : '>=74',
// 	'chromium'                     : '>=74',
// 	'opera'                        : '>=62',
// 	'samsung internet for android' : '>=11.1.1.52'
// };

// const intl = createIntl({ locale: 'en', defaultLocale: 'en' });

// recorder.intl = intl;

if (import.meta.env.VITE_DEBUG === '*' || import.meta.env.MODE !== 'production')
{
	debug.enable('* -engine* -socket* -RIE* *WARN* *ERROR*');
}

// const logger = new Logger();

// const theme = createMuiTheme(config.theme);

const Router = BrowserRouter;
const device = deviceInfo();
const urlParser = new URL(window.location);
const sessionId = urlParser.pathname.split('/')[1];
const parameters = urlParser.searchParams;

function RoomPlugin()
{
	const [ pluginSocket, setPluginSocket ] = useState(null);
	const [ isOnline, setIsOnline ] = useState(navigator.onLine);

	async function getMeetingInfo()
	{

		let projectId;

		if (parameters.get('projectId') !== undefined && parameters.get('projectId') !== null)
		{
			projectId = parameters.get('projectId');
		}
		else
		{
			projectId = sessionStorage.getItem('projectId');

		}

		try
		{
			const res = await axios.get(`${import.meta.env.VITE_inApiPublicAPI}/getSessionToken?sessionId=${sessionId}`);

			if (res.status)
			{
				const sessionToken = res.data.data.sessionToken;

				store.dispatch(roomActions.setRoomToken(sessionToken));

				const sessionData = decodeToken(sessionToken, projectId);
				console.log('sessionData', sessionData);
				console.log('sessionData?.meetingDetails?.scheduleType', sessionData?.meetingDetails?.scheduleType);
				store.dispatch(roomActions.setRoomType(sessionData?.meetingDetails?.scheduleType));
				store.dispatch(roomActions.setCallType(sessionData?.meetingDetails?.callType));
				store.dispatch(roomActions.setSessionName(sessionData?.meetingDetails?.meetingName));

				console.log('sessionData', sessionData, projectId);

				return sessionData;
			}
		}
		catch (err)
		{
			console.log('err', err);
		}

	}

	useEffect(() =>
	{
		let socket;

		if (device.platform === 'desktop' && device.name === 'electron')
		{
			socket = io(import.meta.env.VITE_Hub_Socket_Url,
				{ transports: [ 'websocket', 'polling' ] }
			);
		}

		const fetchMeetingInfo = async () =>
		{
			try
			{
				await getMeetingInfo();

			}
			catch (error)
			{
				console.error('Error fetching meeting info:', error);
				// Handle the error appropriately, e.g., set an error state
			}
		};

		fetchMeetingInfo();

		socket?.on('connect', async () =>
		{
			// console.log('socket connction===');
			setPluginSocket(socket);
			const joinData = await window?.electron?.ipcRenderer?.invoke('requestToJoinRoom');

			console.log('join data on socket connect===', joinData);
			if (joinData && joinData?.controllerUniqueId && joinData?.desktopUniqueId)
			{
				socket?.emit('roomPairingStatus', { status: true, desktopUniqueId: joinData?.desktopUniqueId, controllerUniqueId: joinData?.controllerUniqueId });
			}
		});

		function changeStatus()
		{
			setIsOnline(navigator.onLine);
		}
		window.addEventListener('online', changeStatus);
		window.addEventListener('offline', changeStatus);

		return () =>
		{
			window.removeEventListener('online', changeStatus);
			window.removeEventListener('offline', changeStatus);
		};
	}, []);

	useEffect(() =>
	{
		async function sendDeviceInfo()
		{
			const information = await window?.electron?.ipcRenderer?.invoke('getdeviceInfo');

			console.log('deviceInfo===', information);
			pluginSocket?.emit('deviceInfoResponse', information);
		}

		pluginSocket?.on('deviceInfo', () =>
		{
			sendDeviceInfo();
		});

		pluginSocket?.on('getSystemVolume', async () =>
		{
			try
			{
				const volume = await window?.electron?.ipcRenderer?.invoke('getSystemVolume');

				pluginSocket?.emit('receiveSystemVolume', { volume });
			}
			catch (error)
			{
				console.log('error in get volume', error);
			}
		});

		pluginSocket?.on('setSystemVolume', async (data) =>
		{
			try
			{
				if (data?.volume || data?.volume === 0)
				{
					await window?.electron?.ipcRenderer?.sendMessage('setSystemVolume', data?.volume);
				}
			}
			catch (error)
			{
				console.log('error in set volume', error);
			}

		});

	}, [ pluginSocket ]);

	useEffect(() =>
	{
		// Add an event listener for the 'touchstart' event when the component mounts
		const handleTouchStart = (event) =>
		{
			const screenWidth = window.innerWidth;
			const touchX = event.touches[0].clientX;
			const edgeThreshold = 30; // Adjust this value as needed

			// If the touch event is near the left or right edge of the screen, prevent the default behavior
			if (touchX < edgeThreshold || touchX > screenWidth - edgeThreshold)
			{
				event.preventDefault();
			}
		};

		document.addEventListener('touchstart', handleTouchStart);

		// Remove the event listener when the component unmounts
		return () =>
		{
			document.removeEventListener('touchstart', handleTouchStart);
		};
	}, []); // Empty dependency array ensures the effect runs only once

	return (
		<SnackbarProvider>
			<ControllerContext.Provider value={{
				setPluginSocket,
				pluginSocket,
				isOnline
			}}
			>
				<Router>
					<Suspense fallback={<LoadingView />}>
						<React.Fragment>
							<Switch color='primary'>
								{device.platform === 'desktop' && device.name === 'electron' && <Route exact path='/' component={DesktopRoomsPlugins} />}
								{device.platform === 'desktop' && device.name === 'electron' && <Route exact path='/controllerPair' component={ControllerPair} />}
								{device.platform === 'desktop' && device.name === 'electron' && <Route exact path='/desktop_room' component={ConferenceRoom} />}
								<Route path='/:id' component={VcComponent} />
							</Switch>
						</React.Fragment>
					</Suspense>
				</Router>
			</ControllerContext.Provider>
		</SnackbarProvider>
	);
}
export default RoomPlugin;